import TechPages from "../pages/technologies/index"
export const data = [
    {
        id: 'cloud_services',
        name: 'Cloud Services',
        bgImage: 'https://images.pexels.com/photos/7690088/pexels-photo-7690088.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        page: TechPages[0]
    },
    {
        id: 'devops',
        name: 'DevOps',
        bgImage: 'https://images.pexels.com/photos/7690088/pexels-photo-7690088.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        page: TechPages[1]
    },
    {
        id: 'data_science',
        name: 'Data Science',
        bgImage: 'https://images.pexels.com/photos/7690088/pexels-photo-7690088.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        page: TechPages[2]
    },
    {
        id: 'rpa',
        name: 'Robotic Process Automation',
        bgImage: 'https://images.pexels.com/photos/7690088/pexels-photo-7690088.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        page: TechPages[3]
    },
    {
        id: 'sap',
        name: 'Systems Applications and Products in Data Processing',
        bgImage: 'https://images.pexels.com/photos/7690088/pexels-photo-7690088.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        page: TechPages[4]
    },
    {
        id: 'python',
        name: 'Python',
        bgImage: 'https://images.pexels.com/photos/7690088/pexels-photo-7690088.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        page: TechPages[5]
    }
]